import React, { Component } from "react";
import Input from "../../2/Controls/Input";

class StoreSelectionStep extends Component {
  handleAllStoresChange = (checked) => {
    const { updateFormData } = this.props;
    updateFormData("allStoresSelected", checked);
    updateFormData("specificStoreSelected", !checked);
  };

  handleSpecificStoresChange = (checked) => {
    const { updateFormData } = this.props;
    updateFormData("specificStoreSelected", checked);
    updateFormData("allStoresSelected", !checked);
  };

  handleStoreSelectionChange = (selectedOptions) => {
    const { updateFormData } = this.props;
    // Extract just the values from the selected options if needed
    // or pass the full objects based on your requirements
    updateFormData("associatedStores", selectedOptions);
  };

  render() {
    const { formData, stores, errors } = this.props;

    // Convert stores array to format expected by Input multiselect
    // Assuming stores is array of objects with id/name or just strings
    const storeOptions = stores.map(function(store) {
      if (typeof store === 'string') {
        return { label: store, value: store };
      }
      
      // Using hasOwnProperty to safely access properties
      var label = store.name || store.label || store;
      var value = store.id || store.value || store;
      
      return { label: label, value: value };
    });

    return (
      <div style={{ margin: 0, padding: 0 }}>
        <h2 style={{ fontSize: "24px", fontWeight: "bold", marginBottom: "24px" }}>
          Store Selection
        </h2>
        
        <div style={{ marginBottom: "24px" }}>
          <Input
            type="switch"
            label="Run Campaign For All Stores"
            value={formData.allStoresSelected}
            onChange={this.handleAllStoresChange}
          />
        </div>
        
        <div style={{ marginBottom: "16px" }}>
          <Input
            type="switch"
            label="Run Campaign For Specific Stores"
            value={formData.specificStoreSelected}
            onChange={this.handleSpecificStoresChange}
          />
        </div>
        
        {formData.specificStoreSelected && (
          <div style={{ marginTop: "16px" }}>
            <Input
              type="multiselect"
              label="Select Stores"
              placeholder="Choose stores..."
              value={formData.associatedStores || []}
              onChange={this.handleStoreSelectionChange}
              options={storeOptions}
              error={errors.associatedStores}
            />
          </div>
        )}
      </div>
    );
  }
}

export default StoreSelectionStep;